import React from "react";
import EOpticAndCameraFeature from "../../../../Model/EOpticAndCameraFeature";
import {
  PsrCaptureProfile,
} from "../../../../Model/CaptureProfile";
import { BasicControl } from "../../../Imager/ImagerFeatureControls";
import { Brightness } from "../../../../Model/ImagerCapabilities";

type Props = {
  disabled: boolean;
  brightness: Brightness;
  captureProfile: PsrCaptureProfile;
  onChange: (value: { brightness: number }) => void;
};

export function PsrBrightnessControl({ brightness, captureProfile, disabled, onChange }: Props) {
  if (captureProfile.brightness == null) {
    throw new Error("Capture profile Brightness is null");
  }
  return (
    <BasicControl
      disabled={disabled}
      feature="Bright Field"
      id={"PsrCameraControlFocus"}
      min={brightness.minBrightness}
      max={brightness.maxBrightness}
      value={captureProfile.brightness}
      onValueChanged={(id, value) => {
        onChange({
          brightness: value,
        });
      }}
      unit="%"
      step={0.1}
    />
  );
}
